import React from "react";
import style from "../style/saldo.module.css";
import {
  subtrair,
  conveterParaMonetario,
  converterParaNumero,
} from "../function/funcionalidades";
import { useData } from "../function/method_desp_rec";
import { useNavigate } from "react-router-dom";
import ButtonDown from "./ButtonDown";

export default function Saldo({ mostraOpcao }) {
  const { listaGastos } = useData();
  const { listaReceitas } = useData();
  const { somar } = useData();
  const navigate = useNavigate();

  const newSaldo = subtrair(somar(listaGastos), somar(listaReceitas));

  const cor = (saldo) => {
    const saldoConvert = converterParaNumero(saldo);

    if (saldoConvert < 0) {
      return style.subTitleRed;
    } else {
      return style.subTitle;
    }
  };

  const redirecionar = () => {
    navigate("/informacoes");
  };

  return (
    <div className={style.position}>
      <p className={style.title}>Saldo Projetado</p>
      <p className={cor(newSaldo)}>{conveterParaMonetario(newSaldo)}</p>
      {/*<ButtonDown/>*/}
      {mostraOpcao && (
        <p className={style.informacoes_orgfin} onClick={redirecionar}>
          Saiba sobre as informações prestadas pelo OrgFin
        </p>
      )}
    </div>
  );
}
